import { motion, AnimatePresence } from 'framer-motion';
import { useExperience, phaseIndex } from '@/store/experience';
import { finishCinematic } from '@/lib/cinematic';

// DOM layer for the freefall: the character leaves the frame, the aircraft shrinks above,
// vertical wind streaks sell the speed. The 3D scene underneath does the falling.
export function SkyDiveSequence() {
  const phase = useExperience((s) => s.phase);
  const i = phaseIndex(phase);
  const active = i >= phaseIndex('JUMPING') && i < phaseIndex('WEBSITE');
  const freefall = phase === 'FREEFALL';
  const rushing = phase === 'FREEFALL' || phase === 'CLOUD_TRANSITION';

  return (
    <AnimatePresence>
      {active && (
        <motion.div key="dive" className="fixed inset-0 z-[25] pointer-events-none overflow-hidden" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 1 } }} data-testid="skydive-layer">
          <motion.div className="absolute inset-0 wind-vertical" animate={{ opacity: rushing ? 0.6 : 0 }} transition={{ duration: 0.8 }} />
          {freefall && (
            <>
              <motion.img src="/assets/skydiver.png" alt="" className="absolute left-1/2 top-[30%] w-[40vmin] -translate-x-1/2"
                initial={{ y: '-10%', scale: 0.9, opacity: 1, rotate: 8 }} animate={{ y: '140vh', scale: 0.25, opacity: 0.9, rotate: -14 }} transition={{ duration: 2.4, ease: 'easeIn' }} data-testid="freefall-character" />
              <motion.svg viewBox="0 0 200 60" className="absolute left-1/2 top-[6%] w-40 -translate-x-1/2" initial={{ scale: 1.6, y: 0, opacity: 0.9 }} animate={{ scale: 0.08, y: '-40vh', opacity: 0 }} transition={{ duration: 3, ease: 'easeOut' }} data-testid="aircraft-silhouette">
                <path d="M10 30 L120 22 L170 8 L178 12 L150 26 L190 30 L150 34 L178 48 L170 52 L120 38 L10 30Z" fill="#0a1a3a" opacity="0.85" />
              </motion.svg>
            </>
          )}
          <button type="button" onClick={() => finishCinematic(useExperience)} className="pointer-events-auto absolute right-5 bottom-6 sm:right-10 sm:bottom-10 text-[0.65rem] tracking-[0.35em] uppercase font-display text-white/60 hover:text-white transition-colors" data-testid="skip-intro-button">Skip intro →</button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
